(function () {
  if (window.__iswInit) return;
  window.__iswInit = true;

  function initReveal() {
    var els = document.querySelectorAll('.isw-reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach ? els.forEach(function (e) { e.classList.add('isw-in'); }) : null;
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('isw-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -30px 0px' });
    Array.prototype.forEach.call(els, function (el, i) {
      el.style.transitionDelay = (Math.min(i % 4, 3) * 70) + 'ms';
      io.observe(el);
    });
  }

  function initCountdown() {
    var el = document.getElementById('isw-countdown');
    if (!el) return;
    var t = 15 * 60;
    setInterval(function () {
      if (t > 0) t--;
      var m = Math.floor(t / 60), s = t % 60;
      el.textContent = m + ':' + (s < 10 ? '0' : '') + s;
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initReveal(); initCountdown(); });
  } else {
    initReveal();
    initCountdown();
  }
})();
